<template>
    <!-- 对话框 -->
    <el-dialog title="添加司机推广码" :visible.sync="show" :with-header="false" :before-close="closeDialog" width="40%">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <template>

                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 20vh; overflow-y: auto;">



                    <el-form-item label="数量:" label-width='120px' style="margin-bottom: 0">
                        <el-input v-model="submit_data.num" :placeholder="submit_rules.num.placeholder" style="width: 150px; margin-right:5px">
                        </el-input>

                    </el-form-item>
                   
                </el-form>


                <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center">
                    <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules"
                               :url="submit_url" :JSON_Boolean="false"></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>

                </div>

            </template>


        </div>


    </el-dialog>
</template>

<script>

    var _this;
    export default {
        props: {
            'isShow': Boolean
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

            }
        },
        data() {
            return {


                show: false,
               


                submit_url: '/driver/addWorkPlate',
                // 表单数据
                submit_data: {
                  
                    num: ''
                  

                },

                submit_rules: {

                
                    num: {
                        placeholder: '单次批量最多50',
                        rules: {
                            required: true,
                            message: '批量创建为1-50的数字',
                            regulation: 'between',
                            rulesData: [1, 50]
                        }
                    }
                   
                },

            };
        },
        created() {

            _this = this;

        },
        methods: {


            // 关闭方法
            closeDialog() {
                _this.show = false;
                for (const key in _this.submit_data) {
                    _this.submit_data[key] = '';
                }
              

            },

          


            // 提交
            onSubmitDig() {
                _this.$emit('onSubmit');
                _this.closeDialog();
            }
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

 
</style>
